

module supportportal {
  'use strict';

  export class SupportPortalCtrl implements ng.IController {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      'supportPortalService',
      '$timeout',
      '$q',
      '$mdDialog',
      'debounce',
      '$analytics',
      'partService',
      '$filter',
      'pageMetaService',
      'anchorNavService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ISupportPortalCtrl,
      private supportPortalService: supportportal.ISupportPortalService,
      private $timeout: ng.ITimeoutService,
      private $q: ng.IQService,
      private $mdDialog: ng.material.IDialogService,
      private debounce: navigation.IDebounceService,
      private $analytics: angulartics.IAnalyticsService,
      private partService: part.IPartService,
      private $filter: misc.IAdvancedNumberFilter,
      private pageMetaService: navigation.IPageMetaService,
      private anchorNavService: navigation.IAnchorNavService
    ) {

      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;
      $scope.error = null;
      $scope.item2Serial = null;
      $scope.serial = null;
      $scope.serialFromQuery = null;
      $scope.snInfo = {};
      $scope.documents = {};

      $scope.$watch('$viewContentLoaded', function () {
        $timeout(function () {
          var serialFromQuery = Number(anchorNavService.getQueryValue('sn')) || 0;
          if (serialFromQuery > 100000 && serialFromQuery < 999999) {
            $scope.deviceSerialInput = serialFromQuery;
            $scope.deviceSerialForm.deviceSerialInput.$setDirty();
            $scope.deviceSerialForm.deviceSerialInput.$setTouched();
            $scope.deviceSerialForm.$setDirty();
            $scope.serialFromQuery = serialFromQuery;
            $scope.vm.LoadDataBySerial("" + serialFromQuery);
          }
        }, 0);
      });

    }



    LoadSupportData(ev: MouseEvent, serialnr: string) {
      if (this.$scope.deviceSerialForm.$invalid) return;
      debugger;
      this.supportPortalService.getMacAddresses(serialnr);
    }

    searchByLanguage(documentId: number, documents: part.PartDocument[], languageCode: number) {
      var docs = documents.filter((d) => {
        return d.DocumentId == documentId && d.LanguageCode.some(lc => lc == languageCode);
      });
      if (docs.length > 0) return docs; //found in gui language

      docs = documents.filter((d) => {
        return d.DocumentId == documentId;
      });
      this.$filter('orderBy')(docs, 'LanguageCode');
      return docs;
    }

    GetDataBySerial(ev: MouseEvent) {


      //ignore the not found error, as we need to query the backend to clear it.
      this.$scope.deviceSerialForm.deviceSerialInput.$setValidity('notfound', true);
      this.$scope.deviceSerialForm.deviceSerialInput.$setValidity('protocol', true);
      if (this.$scope.deviceSerialForm.$invalid) return;

      var serialnr = "" + this.$scope.deviceSerialInput;

      this.LoadDataBySerial(serialnr)
    }

    LoadDataBySerial(serialnr: string) {

      this.supportPortalService.itemsBySerial(serialnr).then((resp) => {
        this.anchorNavService.search({ "sn": serialnr });
        this.$scope.serial = serialnr;
        this.$scope.item2Serial = resp.data.data.itemBySerialWithSub;

        if (!this.$scope.item2Serial || this.$scope.item2Serial.length <= 0) {
          this.$scope.deviceSerialForm.deviceSerialInput.$setValidity('notfound', false);
          return;
        }
        // reset not found error.
        this.$scope.deviceSerialForm.deviceSerialInput.$setValidity('notfound', true);

        this.supportPortalService.certsBySerials(this.$scope.item2Serial.map(item => item.serialnumber)).then((resp) => {
          this.$scope.deviceDocuments = resp.data.data.documentsByMultipleSerials.reduce((acc, item) => {
            acc[item.serialnumber] = item.documents;
            return acc;
          }, {});
        }).catch((e: any) => { });

        for (var i = 0; i < this.$scope.item2Serial.length; i++) {
          let item = this.$scope.item2Serial[i];

          this.pageMetaService.searchPage("ProductName", item.productId).then((psck) => {
            if (psck) {
              this.$scope.snInfo[item.serialnumber] = {
                productMenuNode: psck,
                productRouteStack: psck.RouteEntry.RouteParameterStack,
                productImage: psck.RouteEntry.RouteParameterStack[0].Options['Image'],
                productName: psck.RouteEntry.RouteParameterStack[0].DisplayName[this.$scope.meta(navigation.HLFULL)],
                productUrl: psck.RouteEntry.UrlByLanguage[this.$scope.meta(navigation.HLFULL)],
              };
            }
          });

          // @TODO: Software updates are linked to the product, not the item
          //          => Extend PartController => Documents(…)
          //             => Extend Elastic SearchDocuments.SearchByParts(…) 
          this.partService.loadDocumentsByPart(item.itemId).then((resp) => {
            //get the best language of a document.
            //get distinct document ids
            const uniqueDocId = resp.data.map(item => item.DocumentId).filter((value, index, self) => self.indexOf(value) === index)

            const languageCode = this.$scope.meta(navigation.HL) == 'D' ? 1 : 2

            this.$scope.documents[item.serialnumber] = [];
            uniqueDocId.forEach((docId, i, a) => {
              const docs = this.searchByLanguage(docId, resp.data, languageCode);
              if (docs.length > 0) this.$scope.documents[item.serialnumber].push(docs[0]);
            });

          })

        }


        
      }).catch((e: any) => {
        console.error(e);

        this.$scope.deviceSerialForm.deviceSerialInput.$setValidity('protocol', false);

        if (e.status) {
          //this is from the xhr (network problem, iis problem)
          this.$scope.error = `${e.statusText} (${e.status})`;
        }

        if (angular.isArray(e)) {
          // error from graphql
          this.$scope.error = `${e[0].message}`;
        }

      });



    }

    ResetMask = () => {
      this.$scope.item2Serial = undefined;
      this.$scope.documents = null;
      this.$scope.deviceDocuments = null;
      this.anchorNavService.search({ "sn": null });
      //set focus to the input and select ther content  
      this.$timeout(() => {
        const inputElement = angular.element('input[name=deviceSerialInput]') as unknown as HTMLInputElement;
        if (inputElement) {
          inputElement.focus();
          inputElement.select();
        }
      }, 0);
    }
    
    HasDocuments = (documents:part.PartDocument[], types: number[]) => {
      // retrurn true if there is any document that is of a type in types
      return documents.some(doc => types.includes(doc.TypeNameId));
    }

    ProduceDocInfo = (doc: part.PartDocument) => {
      if (!doc) return;
      return doc.RevDestName + " (" + this.$filter('advancedNumber')(doc.RevDestSize, 1024) + 'B)';
    }


    GetDocumentDownloadLink = (document: part.PartDocument) => {
      return "/svc/document.axd?id=" + document.Id + "&hl=" + this.$scope.meta('hl');
    }


  }
};
